import {
  OAUTH_LINK, OAUTH_UNLINK, USER_GET_AUTH_URL, USER_LOGOUT,
} from '@/utils/constants/api-endpoints'
import socket from '@/plugins/socket'

export const getAuthUrl = () => socket.request(USER_GET_AUTH_URL)

export const logout = async () => {
  const resp = await fetch(CONFIG.api.url + USER_LOGOUT, { credentials: 'include' })

  if (!resp.ok) throw new Error(resp.json())
  return resp.json()
}

export const oauthLink = data => socket.request(OAUTH_LINK, data)
export const oauthUnlink = type => socket.request(OAUTH_UNLINK, type)
